import script from "./ImportUsersModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportUsersModal.vue?vue&type=script&setup=true&lang=ts"

import "./ImportUsersModal.vue?vue&type=style&index=0&id=3afd732f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3afd732f"]])

export default __exports__